import ms51 from "./ms51"
import viewloansecurity from "./viewloansecurity";
import ms24 from "./ms24";
import ms47 from "./ms47";
import ms52 from "./ms52";
import viewloanpurpose from "./viewloanpurpose";
import ms53 from "./ms53";
import viewloanpriority from "./viewloanpriority";
import ms54 from "./ms54";
import viewloanaction from "./viewloanaction";
import ms55 from "./ms55";
import createprioritysector from "./createprioritysector";
import ms88 from "./ms88";

export default {
    ms51,
    viewloansecurity,
    ms24,
    ms47,
    ms52,
    viewloanpurpose,
    ms53,
    viewloanpriority,
    ms54,
    viewloanaction,
    ms55,
    createprioritysector,
    ms88
}